import { Middleware } from "../runtime";

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly code?: string,
    public readonly details?: unknown
  ) { super(message); this.name = 'ApiError'; }
}
function isJson(ct: string) {
  return ct.includes('json');
}

async function parseErr(res: Response) {
  const ct = (res.headers.get('content-type') || '').toLowerCase();

  let body: any | string | undefined;

  if (isJson(ct)) {
    try { body = await res.clone().json(); } catch {}
  }
  if (body === undefined) {
    try { body = await res.clone().text(); } catch {}
  }

  const title = (body as any)?.title as string | undefined;
  const detail = (body as any)?.detail as string | undefined;
  const code = (body as any)?.code as string | undefined;

  const message =
    title ??
    detail ??
    (typeof body === 'string' ? body : undefined) ??
    `HTTP ${res.status}`;

  return { message, body, code };
}

export const errorMiddleware: Middleware = {
  async post({ response }) {
    if (response.ok) return response;

    // Normalize ALL non-2xx into ApiError
    const { message, body, code } = await parseErr(response);
    throw new ApiError(message, response.status, code, body);
  },

  async onError() {
    // Network/DNS/CORS/timeout
    throw new ApiError('Network error', 0);
  },
};